<div class="row">
    <div class="col" #content>
        <div class="row">
            <div class="col col-md-12 d-flex align-items-center">
                <h5><i class="fas fa-chart-pie text-primary"></i>
                    {{ usecase?.["name"] }} {{ custom ?
                    'Dynamic': 'Quick' }} Chart
                </h5>
                <div class="pdf-exclude input-group me-2 col-2 ms-1" style="width: 35%;"
                *ngIf="!custom">
                    <button for="SelectAttributes" class="btn btn-outline-primary btn-sm">Field</button>
                    <select class="form-select form-select-sm" id="SelectAttributes" name="SelectAttributes"
                        [(ngModel)]="form.data['field']"
                         [ngClass]="{ 'placeholder-grey': form.data['field'] === undefined }" #SelectAttributes>
                        <option selected value="undefined">--Select--</option>
                        <option *ngFor="let e of filterAttributes()" [value]="e['code']">{{ e["label"] }}</option>
                    </select>
                </div>

                <button class="pdf-exclude btn btn-outline-primary btn-sm me-1" (click)="drawChart()"
                    [disabled]="form.data['field'] === 'undefined'" title="Draw"
                    *ngIf="!custom" >Draw</button>

                <button (click)="getUsecaseSchema()" (click)="resetSearchValues()" title="Refresh"
                    class="pdf-exclude btn btn-outline-primary btn-sm" *ngIf="!custom">
                    <i class="fa fa-sync"></i>
                </button>

                <button (click)="downloadPDF()" title="PDF" class="pdf-exclude btn btn-outline-primary btn-sm ms-1">
                    <i class="fa fa-file-pdf"></i>
                </button>
            </div>
        </div>

        <app-dynamic-chart *ngIf="custom" [attributes]="usecaseAttributes" [data]="usecaseData"
            [collection_name]="usecase?.['collectionName']" />

        <div *ngIf="!custom" class="container">
            <div *ngIf="loading"> loading ...</div>
            <div class="row mt-3" *ngIf="!loading">
                <div *ngIf="usecaseData && usecaseData.length > 0">
                    <div *ngFor="let field of filteredAttributes; let i = index">
                        <div *ngIf="field.type === 'number' || field.type === 'expression' || field.type === 'text'">
                            <div class="row">
                                <div class="col-6 ">
                                    <div class="card">
                                        <div class="card-header">
                                            <h4> {{ field.label }} <i class="bi bi-bar-chart-line text-primary "></i>
                                            </h4>
                                        </div>
                                        <div class="card-body">
                                            <app-ncs-graph [attributes]="usecaseAttributes" [data]="usecaseData"
                                                [collectionName]="usecase?.['collectionName']" [field]="field"
                                                [chartType]="'line'"></app-ncs-graph>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 ">
                                    <div class="card">
                                        <div class="card-header">
                                            <h4> {{ field.label }} <i class="bi bi-bar-chart text-primary "></i>
                                            </h4>
                                        </div>
                                        <div class="card-body">
                                            <app-ncs-graph [attributes]="usecaseAttributes" [data]="usecaseData"
                                                [collectionName]="usecase?.['collectionName']" [field]="field"
                                                [chartType]="'bar'"></app-ncs-graph>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 ">
                                    <div class="card">
                                        <div class="card-header">
                                            <h4>{{ field.label }} <i class="bi bi-pie-chart-fill text-primary"
                                                    title="Pie Chart"></i> </h4>
                                        </div>
                                        <div class="card-body">
                                            <app-ncs-graph [attributes]="usecaseAttributes" [data]="usecaseData"
                                                [collectionName]="usecase?.['collectionName']" [field]="field"
                                                [chartType]="'pie'"></app-ncs-graph>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 ">
                                    <div class="card">
                                        <div class="card-header">
                                            <h4> {{ field.label }} <i class="bi bi-opencollective text-primary"
                                                    title="Doughnut Chart"></i></h4>
                                        </div>
                                        <div class="card-body">
                                            <app-ncs-graph [attributes]="usecaseAttributes" [data]="usecaseData"
                                                [collectionName]="usecase?.['collectionName']" [field]="field"
                                                [chartType]="'doughnut'"></app-ncs-graph>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="page-break"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>